/* eslint-disable */
import { StyleSheet, Dimensions } from 'react-native'
import { ApplicationStyles, Fonts } from '../../Themes/'
const { width, height } = Dimensions.get('window')
export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1,
  },
  bar: {
    height: 130,

  },

  alert: {
    position: `absolute`,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    justifyContent: `center`,
    alignItems: `center`,
    backgroundColor: `transparent`
  },
  sharing: {
    backgroundColor: `white`,
    bottom: 0,
    right: 0,
    left: 0,
    position: `absolute`
  },
  avoiding: {
    paddingTop: 0
  },
  whitecolor: {
    backgroundColor: `#FFFFFF`
  },
  noneColor: {
    backgroundColor: 'transparent'
  },
  rightTitleStyle: {
    color: '#555'
  },
  styleMiddlebar: {
    marginTop: 10
  },
  containerBottomBar: {
    flex: 1,
    flexDirection: `row`
  },
  divider: {
    width: 2,
    height: 60,
    marginTop: 10
  },
  image: {
    height: height - 64 - 120 // this gets computed later when we have data
    , width: width
    , resizeMode: 'contain'
    , backgroundColor: 'white'
  },
  video: { // start w/ same as image, may need to adjust separately for vid
    backgroundColor: 'white',
    height: height - 64 - 120, // this gets computed later when we have data
    width: width
  },
  top: {
    flex: 1,

  },
  textInputStyle: {
    margin: 5,
    paddingBottom: 30,
    flex: 1,
    fontSize: 15,
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.9,
    shadowRadius: 2,
    elevation: 1,
  },
  keyboadTop: {
    position: 'absolute',


    backgroundColor: 'transparent',
    top: 0,
    left: 0,
    right: 0,
    height: 1000
  },
  bottom: {
    position: 'absolute',

    top: height - 64 - 130,
    backgroundColor: 'transparent',

    left: 0,
    right: 0,
   // height: height - 44 - 70
   bottom : 0
  },
  textStyle: {
    color: 'black',
    paddingTop: 0,

  },
  textStyleActive: {
    color: Fonts.style.color.green,
    paddingTop: 0,

  },
  bottomBar: {
    flexDirection: `row`,
    height: 60,
    width: width,
    backgroundColor: 'white'

  },
  commentBox: {
    height: 70,
    width: width,
    backgroundColor: 'black'

  },
  containerStyle: {

    backgroundColor: 'white',
  },
  styleBorder: {
    marginTop: -20,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    backgroundColor: 'white',
    overflow: 'hidden',
  },
  postDetail: {
/*
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
*/
    height: 40,
    backgroundColor: 'white', // 'rgb(154,154,154)',
    // margin: 1,
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 0,
    borderTopWidth: 1,
    borderColor: 'rgb(225,225,225)'
  },
  postDetailPin: {
    marginLeft: 5,
    marginRight: 10,
    width: 25
  },
  postDetailPinSize: 25,
  postMusicDetailPinSize: 20,
  postDetailTextWrapper: {
    flex: 1,
  },
  postDetailText: {
    fontFamily: Fonts.style.font.regular,
    fontSize: 14,
    // flex : 1,
  },
  postDetailX: {
    marginLeft: 5,
    marginRight: 5,
    right: 0,
    width: 25,
    justifyContent: `center`,
    alignItems: `center`,
  },
  postDetailAlbumIcon: {
    marginLeft: 5,
    marginRight: 5,
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: 'green',
  },
  postDetailXSize: 14, // 25,

})
